<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="my-5 error-no-expand fill-height align-items-center justify-content-center ">
		<div v-if="this.isCompletedAll" class="text-center">
			Your calendar is connected. Please proceed to the next step.
		</div>
		<SchedulerWizard
			v-else
            :allowAlreadyConnected="allowAlreadyConnected"
			@onSetupCompletedChange="onSetupCompletedChange"
			@onCompleteSetup="onSchedulerWizardStepCompleteClicked"/>
<!--		<el-form :model="form" :rules="rules" ref="mainForm" @submit.native.prevent="submitForm()">-->

<!--			<el-steps direction="horizontal"-->
<!--					  align-center-->
<!--					  :active="activeStep"-->
<!--					  finish-status="success"-->
<!--					  process-status="finish"-->
<!--					  class="steps-light"-->
<!--					  :space="space">-->
<!--				<el-step v-for="(step, index) in steps" :key="index"-->
<!--						 :title="step.title">-->
<!--				</el-step>-->
<!--			</el-steps>-->
<!--			<transition :name="transitionName" mode="out-in" @enter="onComponentChanged">-->
<!--				<keep-alive>-->
<!--					<component ref="contentComponent"-->
<!--							   :is="activeComponentClass"-->
<!--							   :key="activeStep"-->
<!--					/>-->
<!--				</keep-alive>-->
<!--			</transition>-->
<!--		</el-form>-->
	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import {delay} from "@/utils/helpers";
import StepSetupUrl from "@/core/modules/coach/Scheduler/SetupWizard/StepSetupUrl.vue";
import WizardStep from "@/core/components/Wizard/WizardStep";
import StepConnectCalendar from "@/core/modules/coach/Scheduler/SetupWizard/StepConnectCalendar.vue";
import StepSetupAvailability from "@/core/modules/coach/Scheduler/SetupWizard/StepSetupAvailability.vue";
import SchedulerWizard from "@/core/modules/coach/Scheduler/SetupWizard/SchedulerWizard.vue";

export default {
	name: "ConnectCalendarStep",
	components: {SchedulerWizard},
	extends: BaseWizardStep,

    props: {
        allowAlreadyConnected: Boolean
    },

	data() {
		return {
			isCompletedAll: false,
			transitionName: "slide",
			activeStep: 0,
			space: null,
			steps: [
				new WizardStep("Set your personal link", StepSetupUrl),
				new WizardStep("Connect calendar", StepConnectCalendar),
				new WizardStep("Set your availability", StepSetupAvailability),
			],
			form: {
				title: '',
				isGroup:false,
			},
			rules: {
				title: [
					{
						required: true,
						whitespace: false,
						message: 'Please specify name of this program',
						trigger: 'validate'
					},
				],
			},

			programItem: null
		}
	},

	methods:{
		// async validateForm(){
		// 	return true
		// }

		stepId(){
			return "connect_calendar_step"
		},

		isStepRequired(){
			return true
		},

		onComponentChanged(){
			this.$forceUpdate()
		},

		hideActionButtons(){
			return !this.isCompletedAll
		},

		onSetupCompletedChange(isCompletedAll){
			console.log("onSetupCompletedChange: ", isCompletedAll)
			this.isCompletedAll = isCompletedAll
			if(isCompletedAll){
				this.activeStep = this.steps.length
			}
		},

		onSchedulerWizardStepCompleteClicked(activeStep){
			this.activeStep = activeStep
			console.log("onSchedulerWizardStepCompleteClicked: activeStep = ", activeStep)
			this.nextStep()
		},

		async onNextClicked(){
			if(!this.isCompletedAll){
				this.transitionName = "slide"
				this.activeStep++
				this.isCompletedAll = this.activeStep >= this.steps.length
			}
			return this.isCompletedAll
		},

		async onPrevClicked(){
			if(!this.isCompletedAll){
				this.transitionName = "slideBack"
				this.activeStep--
			}
			return this.isCompletedAll || this.activeStep < 0
		},

		async updateProgramItem(){
			if(this.programItem.name !== this.form.title){
				this.programItem.name = this.form.title;
				await delay(500)
				// await this.$dataManager.updateProgram(this.programItem)
			}
		},

		getProgressText(){
			return "Saving..."
		},


		getTrimmedStep(){
			return Math.min(this.steps.length - 1, Math.max(0, this.activeStep))
		},

		async onStepEntered(){
			console.log("ConnectCalendarStep onStepEntered")
			this.activeStep = this.getTrimmedStep()
		}
	},

	computed:{
		activeComponentClass() {
			let activeStep = this.steps[this.getTrimmedStep()]
			return activeStep.component
		},
	}
}
</script>

<style src="@/core/modules/coach/Scheduler/SetupWizard/SchedulerWizard.scss" lang="scss" scoped/>

<style lang="scss" scoped>
//@import "@/core/client/coach/Scheduler/SetupWizard/SchedulerWizard";
</style>
